/** ========================================================================= *\
 * @prefab End House
 * ========================================================================== */

class EndHouseBackground extends Phaser.Sprite {

  /** @constructor ---------------------------------------------------------- */
  constructor(game, x, y) {
    super(game, x, y, 'end-house-background');
    this.anchor.set(0, 1);
    this.scale = new Phaser.Point(0.6, 0.6);
  }

}

class EndHouseForeground extends Phaser.Sprite {

  /** @constructor ---------------------------------------------------------- */
  constructor(game, x, y) {
    super(game, x, y, 'end-house-foreground');
    this.anchor.set(0, 1);
    this.scale = new Phaser.Point(0.6, 0.6);
  }

}

export { EndHouseBackground, EndHouseForeground };


// WEBPACK FOOTER //
// ./js/prefabs/endHouse.js